module.exports = __webpack_public_path__ + "media/assets/icons/reflection-room-6d6d0da40a058bb6bdbb2eef2318787d.png";